import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListItem } from '../models/lists.model';
import { GenericListService } from './lists.service';

export enum ARBleListType {
  // Verse
  BLE_AZOTE_FREQUENCIES,
  VERSE_APPORTS_MINERAUX_FRACTIONNEMENT,
  VERSE_APPORT_MO_AUTOMNE,
  // TODO PPF : remove
  BLE_AZOTE_PRODUCT_TYPES,
  BLE_ETATS_VEGETATIFS_SH,
  BLE_AZOTE_PERIODS,
  BLE_PAST_RESIDU_TYPES,
  BLE_PRAIRIE_AGES,
  BLE_PRAIRIE_DESTRUCTION_PERIODS,
  BLE_PRAIRIE_POST_DESTRUCTION_RANKS,
  BLE_PRAIRIE_EXPLOITATION_MODES,
  BLE_PRAIRIE_TYPES,
  BLE_CI_TYPES,
  BLE_CI_DEVELOPMENTS,
  BLE_CI_DESTRUCTION_PERIODS,
  BLE_RESULT_TYPES,
  BLE_ORDER_TYPES,
}

// TODO refactor lists.service pour ne pas dupliquer le code commun avec ARColza ?
@Injectable({ providedIn: 'root' })
export class ARBleListsService extends GenericListService<ARBleListType> {
  constructor(http: HttpClient) {
    super(http);
    this.listsUrl = '/tools/agrorendement/ble/lists';
  }

  handleResponse(response: any) {
    const data = response.data;
    const converted = new Map<ARBleListType, ListItem[]>();
    for (const d in data) {
      const listType: ARBleListType = <any>ARBleListType[<any>d];
      const value = data[d];
      const typeData = value.map(this.extractI18n);
      converted.set(listType, typeData);
      this.cache.set(listType, typeData);
    }
    return converted;
  }
}
